import React from "react";
import { Reveal } from "../tools/Reveal";
import { RevealGroup } from "../tools/RevealGroup";
import avatar from "../images/webp/avatar.webp";
import linkedin from "../images/webp/linkedin-logo.webp";
// import arrowSymbol from "../images/arrow-symbol.png";
import "../styles/Testimonials.scss";

function Testimonials() {
  return (
    <div className="testimonials" id="testimonials">
      <RevealGroup>
        <div className="section-title-wrapper">
          <Reveal direction={"top"}>
            <h5 className="section-title">TESTIMONIALS</h5>
            <h2 className="section-subtitle">
              Recognition that drives me forward
            </h2>
          </Reveal>
        </div>
        <div className="testimonials-container">
          <section className="card-container">
            <Reveal direction={"bottom"}>
              <div className="card">
                <div className="testimonial-top">
                  <img
                    className="user-pic"
                    src={avatar}
                    alt="personal pic of the person"
                  />
                  <a
                    href="https://www.linkedin.com/in/rpfkoster/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="testimonial-linkedin"
                      src={linkedin}
                      alt="linkedin logo"
                    />
                  </a>
                </div>
                <div className="testimonial-center">
                  "Feridun has demonstrated a solid understanding and comfort
                  with JavaScript and React, which has been a valuable asset to
                  our projects. His proficiency has consistently contributed to
                  our team's success. Moreover, he willingly shares his
                  knowledge, benefitting the team's growth. Beyond his skills,
                  Feridun fosters a positive work environment with calm and
                  composed demeanor, optimistic attitude and collaborative
                  spirit. He is a team player who goes the extra mile to help
                  his team members where he can."
                </div>
                <div className="testimonial-bottom">
                  <h3>Robert Koster</h3>
                  <h4 id="testimonial-title">Founder of AerLabs</h4>
                </div>
              </div>
            </Reveal>
          </section>
          <section className="card-container">
            <Reveal direction={"bottom"}>
              <div className="card">
                <div className="testimonial-top">
                  <img
                    className="user-pic"
                    src={avatar}
                    alt="personal pic of the person"
                  />
                  <a
                    href="https://www.linkedin.com/in/erselaker/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="testimonial-linkedin"
                      src={linkedin}
                      alt="linkedin logo"
                    />
                  </a>
                </div>
                <div className="testimonial-center">
                  "Feridun has been a star student during his software
                  development bootcamp; always going the extra mile with his
                  innate skill and curiosity. He is a fast learner and
                  methodical in his thinking. He would make a great addition to
                  any engineering team."
                </div>
                <div className="testimonial-bottom">
                  <h3 className="testimonial-name">Ersel Aker</h3>
                  <h4 id="testimonial-title">Founder of CyprusCodes</h4>
                </div>
              </div>
            </Reveal>
          </section>
        </div>
      </RevealGroup>
    </div>
  );
}

export default Testimonials;
